(function importImagesProcessControllerDefinition() {
    'use strict';

    angular.module('ImportImagesProcess')
        .controller('ImportImagesProcessDetailController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'importImagesProcessService', '$stateParams', 'authExtend', 'alerts', 'fileService',
            function importImagesProcessController($scope, config, $state, $translate, errors, importImagesProcessService, $stateParams, authExtend, alerts, fileService) {

        $scope.accesPurge = authExtend.isInRole('PROCESSIMAGES PURGE');

        $scope.hasFiles = true;
        $scope.hasErrors = false;

        $scope.load = function () {

            importImagesProcessService.getById($stateParams.id)
                .then(function (result) {
                    $scope.import = result;
                    $scope.hasErrors = $scope.import.errors.length > 0;
                    $scope.hasFiles = $scope.import.files.length > 0;
                    for (var i = 0; i < $scope.import.files.length ; i++) {
                        $scope.import.files[i].fsize = fileService.FormatfileSize($scope.import.files[i].size);
                    }
                }, function (error) {
                    errors.showError(error);
                });
        }

        $scope.cancel = function () {
            $state.goBack('import-images-process-find');
        };

        $scope.downloadFile = function (file) {
            return importImagesProcessService.downloadFile(file);
        };

        $scope.Purge = function () {
            return $translate(['ImportProcessPurge', 'ImportProcessByIdeConfirmationMessage', 'ImportProcessConfirmationContinue', 'Yes', 'No']).then(function (translated) {
                var message = translated.ImportProcessByIdeConfirmationMessage + translated.ImportProcessConfirmationContinue;
                return alerts.confirm(translated.ImportProcessPurge, message, translated.Yes, translated.No).then(function getOk(result) {
                    if (result) {
                        return importImagesProcessService.PurgeById($scope.import.id).then(function getOk(result) {
                            location.reload();
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                });
            });
        };


        $scope.load();
    }
        ]);
})();